
import React, { useCallback, useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { Accordion } from "react-bootstrap";
import "./Questions.css";
import ScreenLoader from "../../../HtmlElements/ScreenLoader";
import { useParams } from "react-router-dom";
import {
  fetchAccountBUUseCaseQuestions,
  fetchGrowthOpportunitiesByAccountAndClient,
} from "../../../../services/accIqService";

import * as FeatherIcon from 'react-feather';
import { removeMarketAtEnd, getUserStatsObject, recordActivity } from "../../../../services/commonService";
import { useSelector } from "react-redux";

export default function Questions({active_tab_key}) {
  const { account_info} = useSelector(state=>state?.accountsReducer)

  const [business_units, setBusinessUnits] = useState([]);
  const [tabs, setTabs] = useState([]);

  const [loader, setLoader] = useState(true);
  const [activeUnit, setActiveUnit] = useState("");
  const [activeMarketIndex, setMarketIndex] = useState("");
  const [allGrowthOpportunitiesList, setAllGrowthOpportunitiesList] = useState([]);
  const [buUseCases, setBuUseCases] = useState([]);
  const [activeUnitQuestions, setActiveUnitQuestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [copied, setCopied] = useState(false);

  const tabContainerRef = useRef(null); // Reference for tab container
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [showArrows, setShowArrows] = useState(false); // New state to control arrow visibility

  const [activeAccordion, setActiveAccordion] = useState('0');
  const [activeIndex, setActiveIndex] = useState(['hide_block']);

  const { accountId, accountName, clientName } = useParams();

  const updateBusinessUnits = useCallback(() => {
    const business_units = account_info?.business_units || [];
    setBusinessUnits(business_units);
    const bu_tabs = business_units.map((unit) => unit.name);
    setTabs(bu_tabs);
    setActiveUnit(bu_tabs[0]);
    handleAccordClick('0');
  }, [account_info]);

  useEffect(() => {
    updateBusinessUnits();
  }, [updateBusinessUnits]);

  useEffect(() => {
    const fetchOpportunities = async () => {
      if (active_tab_key === 'questions') {
        let userStat = getUserStatsObject("Questions", "page_load", "Data: "+activeUnit+", Page Source: "+accountName, window.location.href, accountId);
        recordActivity(userStat);
        setLoader(true);
        try {
          const opportunities_data = await fetchGrowthOpportunitiesByAccountAndClient(accountId, accountName, clientName);
          let opportunities_list = opportunities_data?.opportunities || [];
          setAllGrowthOpportunitiesList(opportunities_list);
          handleAccordClick('0');
          updateScrollButtons();
        } catch (error) {
          console.error("Failed to fetch growth opportunities:", error);
        }
        setLoader(false);
      }
    };
  
    fetchOpportunities();
  }, [active_tab_key, accountId, accountName, clientName]);
  
  const fetchSegmentData = useCallback(async (bu_unit) => {
    setLoader(true);
    setMarketIndex("");
    setBuUseCases([]);
    try {
      const use_cases_filtered = allGrowthOpportunitiesList.filter((use_case) => use_case.business_unit === bu_unit);
      setBuUseCases(use_cases_filtered.map((use_case) => use_case.data.market));
      setMarketIndex(0);
      handleAccordClick('0');
    } catch (error) {
      console.error("Error fetching segment data:", error);
    } finally {
      setLoader(false);
    }
  }, [allGrowthOpportunitiesList]);

  const fetchSegmentQuestions = useCallback(async (title) => {
    setSelectedItems([]);
    if (title) {
      setLoader(true);
      try {
        const acc_bu_questions = await fetchAccountBUUseCaseQuestions(accountName, clientName, activeUnit, title);
        if(acc_bu_questions !== undefined && Object.keys(acc_bu_questions).length){
          const filteredQuestions = acc_bu_questions?.prompter_questions?.data?.filter(q => q?.useCase?.trim() !== "") || [];
          setActiveUnitQuestions({ ...acc_bu_questions, prompter_questions: { data: filteredQuestions } });
          // handleAccordClick('0');
        }else{
          setActiveUnitQuestions([]);
        }
      } catch (error) {
        console.error("Error fetching segment questions:", error);
        setActiveUnitQuestions([]);
      } finally {
        setLoader(false);
      }
    } else {
      setMarketIndex("");
      setActiveUnitQuestions([]);
    }
  }, [accountName, clientName, activeUnit]);

  const changeActiveUnit = (activeUnit) =>{
    let userStat = getUserStatsObject("Questions", "page_load", "Data: "+activeUnit+", Page Source: "+accountName, window.location.href, accountId);
    recordActivity(userStat);
    setMarketIndex("");
    setActiveUnit(activeUnit);
    setActiveIndex('hide_block');
    handleAccordClick('0');
  }

  useEffect(() => {
    if (activeUnit) {
      fetchSegmentData(activeUnit);
    }
  }, [activeUnit, fetchSegmentData]);

  useEffect(() => {
    if (activeUnit && activeMarketIndex !== "") {
      let userStat = getUserStatsObject("Questions", buUseCases[activeMarketIndex], "Data: "+activeUnit+", Page Source: "+accountName, window.location.href, accountId);
      recordActivity(userStat);
      fetchSegmentQuestions(buUseCases?.[activeMarketIndex] || "");
      handleAccordClick('0');
    }
  }, [activeMarketIndex, fetchSegmentQuestions, buUseCases]);


  const handleCheckboxChange = (question_index) => {
    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.includes(question_index)
        ? prevSelectedItems.filter((id) => id !== question_index)
        : [...prevSelectedItems, question_index]
    );
  };

  const handleCopyToClipboard = () => {
    let textToCopy = "";
    const textToCopyArr = selectedItems
      .map((id) => {
          let questions = activeUnitQuestions?.prompter_questions?.data ? activeUnitQuestions.prompter_questions.data : [];
          const ques = questions.find((question, index) => {
            return index === id
          });
          return ques ? ques : "";
      });
    
    // Loop through the array and build the formatted text
    textToCopyArr?.forEach((item) => {
      textToCopy += `${item.useCase}:\n\n`; // Add the use case
      textToCopy += "Value Selling Prompters:\n"; // Add the section header

      // Loop through the value selling prompters and append their levels and questions
      item?.valueSellingPrompters?.forEach((prompter) => {
        textToCopy += "\t" + `Level ${prompter?.level}: ${prompter?.question}\n`;
      });

      textToCopy += "\nDifferentiators:\n"; // Add the differentiators section header

      // Loop through differentiators and append them
      item?.differentiator?.forEach((diff) => {
        textToCopy += "\t" + `${diff}\n`;
      });

      textToCopy += "\n\n\n"; // Add spacing between use cases
    });

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
    });

    setTimeout(() => {
      setCopied(false);
    }, 2000);

  };

  const updateScrollButtons = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      const canScrollLeftValue = tabContainer.scrollLeft > 0;
      const canScrollRightValue = tabContainer.scrollLeft + tabContainer.clientWidth < tabContainer.scrollWidth;

      setCanScrollLeft(canScrollLeftValue);
      setCanScrollRight(canScrollRightValue);

      // Show arrows only if the content is scrollable
      setShowArrows(tabContainer.scrollWidth > tabContainer.clientWidth);
    }
  };

  const scrollLeft = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    updateScrollButtons(); // Initially check if scrolling is needed
    const tabContainer = tabContainerRef.current;
    
    if (tabContainer) {
      tabContainer.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons); // Recheck on window resize
    }

    return () => {
      if (tabContainer) {
        tabContainer.removeEventListener('scroll', updateScrollButtons);
      }
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [tabs]);

  // +++++++++++++++++++++++++++
  const handleAccordClick = (index) => {
    setActiveAccordion(!activeAccordion.toString()); //Close the currently open accordion if cliked it
    if (activeAccordion.toString() !== index.toString()) {
      setActiveAccordion(index.toString()); // Open newly clicked accordion
    }
  };

  const handleShowBlock = (index) => {
    const newActiveIndex = [...activeIndex];
    newActiveIndex[index] = 'show_block';
    setActiveIndex(newActiveIndex);
  };

  const handleHideBlock = (index) => {
    const newActiveIndex = [...activeIndex];
    newActiveIndex[index] = 'hide_block';
    setActiveIndex(newActiveIndex);
  };
  // +++++++++++++++++++++++++++

  if (!allGrowthOpportunitiesList || !business_units.length) {
    return <> </>; // Provide some feedback while loading
  }

  return (
    <div className="questions_wrapper pb-4">
      {loader && <ScreenLoader />}
      <div className="business_seg_tabs">
        <div className="navbar navbar-expand-lg container custom_subnavbar">
          {showArrows && (
            <>
              <button
                className="scroll-btn left-arrow"
                onClick={scrollLeft}
                disabled={!canScrollLeft}
              >
                <FeatherIcon.ArrowLeftCircle className='icons_table mr-1' />
              </button>
            </>
          )}
          <ul className="nav nav-tabs custom_nav_tab" ref={tabContainerRef}>
            {tabs.map((tab) => (
              <li className="nav-item" key={`que_seg_unit_${tab}`}>
                <a
                  className={`nav-link ${activeUnit === tab ? "active" : ""}`}
                  onClick={() => changeActiveUnit(tab)}
                >
                  {tab}
                </a>
              </li>
            ))}
          </ul>
          {showArrows && ( // Conditionally render arrows based on `showArrows` state
            <>
              <button
                className="scroll-btn right-arrow"
                onClick={scrollRight}
                disabled={!canScrollRight}
              >
                <FeatherIcon.ArrowRightCircle className='icons_table mr-1' />
              </button>
            </>
          )}
        </div>
      </div>

      <div className="container">
        <div className="questions_block mt-4 ">
          {(activeUnitQuestions?.prompter_questions?.data?.length > 0) && (<div className="row">
            <div className="col-md-3">
              <div className="questions_left_sidebar">
                <div className="sidebar_head">
                  <h5 className="sidebar_main_head">Growth Opportunities</h5>
                </div>
                <div className="sidebar_sublist">
                  {activeMarketIndex !== "" &&
                  <ul className="sidebar_ul">
                    {buUseCases?.length > 0 && (
                      <>
                        {buUseCases.map(
                          (marketInfo, index) => (
                            <li
                              className={`sidebar_list ${
                                index === activeMarketIndex ? "active" : ""
                              }`}
                              key={index}
                            >
                              <a
                                href="#"
                                className="link_sidebar"
                                onClick={() => setMarketIndex(index)}
                              >
                              <img src="/img/icons/help-circle.png" alt="icons" width="16" className="icons_nav mr-2"/>{" "}
                                {removeMarketAtEnd(marketInfo)}
                              </a>
                            </li>
                          )
                        )}
                      </>
                    )}
                  </ul>
                  }
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="questions_right_sidebar">

                {activeUnitQuestions?.prompter_questions?.data?.length > 0 &&
                <div className="copy_btn_block">

                  <span className={`copy-message ${copied ? 'copy-fade-in' : 'copy-fade-out'}`}>
                    Copied to clipboard!
                  </span>

                  <button 
                    disabled={selectedItems.length === 0}
                    className="copy_btn"
                    onClick={handleCopyToClipboard}
                  >
                    <img
                      src="/img/icons/copy.png"
                      alt="logo"
                      width="20"
                      className=""
                    />{" "}
                    Copy <span>{selectedItems.length}</span> Items
                  </button>
                </div>
                }


                    <Accordion 
                      // defaultActiveKey="0"
                      activeKey={activeAccordion?.toString()}
                      // key={index}
                    >
                      {activeUnitQuestions?.prompter_questions?.data.map((questionObj, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index} className="m-2">
                          <Accordion.Header className="accordian_header" onClick={() => handleAccordClick(index)}>
                            <img
                              src="/img/icons/question_prompters.png"
                              alt="logo"
                              className="ques_logo"
                            />
                            <p className="accordian_head">
                            {questionObj?.useCase}
                            </p>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="accordian_body_para" style={{display: "block"}} key={index}>
                           
                              
                              <p className="accordian_content mt-2 mb-2">
                              <Form.Check
                                aria-label="option 1" className="mr-1"
                                onChange={() =>
                                  handleCheckboxChange(index)
                                }
                                checked={selectedItems.includes(index)} 
                                style={{display: "inline-block"}}
                              /> 
                              <span className="promter_subhead">Value Selling Prompters</span>
                              </p>
                              <ul className="promter_ul">
                                {questionObj?.valueSellingPrompters.map((vsp, index2) => (
                                  <li className="promter_li mb-1"><b>Level {vsp.level} : </b>{vsp.question}</li>
                                ))}
                              </ul>

                              {activeIndex[index] === 'hide_block' ? (<div>
                                <p className="show_more mb-1 overview_sidecard"><span className="read_more_prompters" onClick={() => handleShowBlock(index)}>Read More</span></p>
                              </div>) : (<div>
                                <p className="accordian_content mt-2 mb-2">
                                  <span className="promter_subhead">Differentiators</span>
                                </p>
                                <ul className="promter_ul">
                                  {questionObj?.differentiator.map((diff, index3) => (
                                    <li className="promter_li mb-1">{diff}</li>
                                  ))}
                                </ul>
                                <p className="show_more mb-1 overview_sidecard"><span className="read_more_prompters" onClick={() => handleHideBlock(index)}>Read Less</span></p>
                              </div>)}
                              {/* ++++++++++++++++++++++++ */}

                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>
  );
}
